import React, { useContext, useRef, useEffect, useState } from "react";
import "../../assets/styles/Preview.scss";
import { StoreContext } from "../context/Store";

import html2canvas from "html2canvas";
import Template1 from "../templates/Template1";
import Template2 from "../templates/Template2";
import Template3 from "../templates/Template3";

// import CVFull from "../../assets/img/cv-3-full.jpg";
import "../../assets/fonts/montserrat-normal";
import "../../assets/fonts/montserrat-bold";
import { Language, SelectBlockOption } from "../../types";
import { returnActive } from "../utils";

window.html2canvas = html2canvas;

export interface PreviewProps {}

export interface PreviewState {}

export const Preview = React.forwardRef<HTMLDivElement, PreviewProps>(
  (props, ref) => {
    const store = useContext(StoreContext);
    const { activeTemplate } = store;
    const wrapper = useRef<HTMLDivElement>(null);
    const [src, setSrc] = useState<string | null>(null);
    const [scale, setScale] = useState({ scale: 1, height: 297 });

    const [activeLanguages, setActiveLanguages] = useState<Language[]>([]);
    const [activeSkills, setActiveSkills] = useState<SelectBlockOption[]>([]);
    const [activeExperience, setActiveExperience] = useState<
      SelectBlockOption[]
    >([]);
    const [activeCourses, setActiveCourses] = useState<SelectBlockOption[]>([]);

    const scaleCV = () => {
      if (wrapper.current) {
        const wrapperWidth = wrapper.current.clientWidth;
        const initialWidth = 210;
        const initialHeight = 297;
        const newScale = wrapperWidth / initialWidth;
        setScale({ scale: newScale, height: initialHeight * newScale });
      }
    };

    const parseFile = (file: File) => {
      return new Promise<string>((resolve) => {
        const reader = new FileReader();
        reader.onload = (e: ProgressEvent<FileReader>) => {
          if (e.target) {
            resolve(e.target.result as string);
          }
        };
        reader.readAsDataURL(file);
      });
    };

    useEffect(() => {
      if (store.userImage.image) {
        parseFile(store.userImage.image).then((source) => {
          setSrc(source);
        });
      }
    }, [store.userImage.image]);

    useEffect(() => {
      window.addEventListener("resize", scaleCV);
      return () => {
        window.removeEventListener("resize", scaleCV);
      };
    }, []);

    useEffect(() => {
      scaleCV();
    }, []);

    useEffect(() => {
      setActiveLanguages(returnActive(store.languages) as Language[]);
    }, [store.languages]);

    useEffect(() => {
      setActiveSkills(returnActive(store.skills) as SelectBlockOption[]);
    }, [store.skills]);

    useEffect(() => {
      setActiveExperience(
        returnActive(store.experience) as SelectBlockOption[]
      );
    }, [store.experience]);

    useEffect(() => {
      setActiveCourses(returnActive(store.courses) as SelectBlockOption[]);
    }, [store.courses]);

    const returnTemplate = () => {
      const props = {
        ref,
        store: store,
        userImage: src,
        activeLanguages,
        activeSkills,
        activeExperience,
        activeCourses,
      };
      switch (activeTemplate + 1) {
        case 1: {
          return <Template1 {...props} />;
        }
        case 2: {
          return <Template2 {...props} />;
        }
        case 3: {
          return <Template3 {...props} />;
        }
      }
    };

    return (
      <div id="preview-path">
        <div id="cv-preview">
          <div
            className="cv-wrapper"
            style={{ height: scale.height }}
            ref={wrapper}
          >
            <div id="scale" style={{ transform: `scale(${scale.scale})` }}>
              {/* <img className="template" src={CVFull} alt="" /> */}
              {returnTemplate()}
            </div>
          </div>
        </div>
      </div>
    );
  }
);

export default Preview;
